export default function sortFn(sortBy) {
  const [field, order] = sortBy.split(':');
  return order === 'asc'
    ? (a, b) => String(a[field] ?? '').localeCompare(String(b[field] ?? ''))
    : (a, b) => String(b[field] ?? '').localeCompare(String(a[field] ?? ''));
}
